import React from "react";
import { injectIntl } from "react-intl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// path constants
import * as paths from '@app/constants/paths';
import * as plans from '@app/constants/plans';
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import NavPills from "@app/components/NavPills/NavPills";

// Component
import PricingCard from "@app/components/CustomCards/PricingCard";

import pricingStyle from "@app/assets/jss/material-kit-pro-react/views/sectionsSections/pricingStyle";

const SectionPricingShorter = props => {
  const { classes } = props;

  const onlineFeatures = [
    {
      name: props.intl.formatMessage({ id: "custom.web.address" }),
      description: 'LocalPro.ie/' + props.intl.formatMessage({ id: "your.biz.name" })
    },
    {
      name: props.intl.formatMessage({ id: "contact.details.page" }),
      description: props.intl.formatMessage({ id: "maps.and.messages" })
    }
  ]

  const businessFeatures = [
    {
      name: props.intl.formatMessage({ id: "booking.system" }),
      description: props.intl.formatMessage({ id: "customers.book.online" })
    },
    {
      name: props.intl.formatMessage({ id: "google.biz.listing" }),
      description: props.intl.formatMessage({ id: "show.up.google.search" })
    }
  ]

  const enterpriseFeatures = [
    {
      name: props.intl.formatMessage({ id: "invoicing" }),
      description: props.intl.formatMessage({ id: "saves.time.paid.faster" })
    },
    {
      name: props.intl.formatMessage({ id: "payments" }),
      description: props.intl.formatMessage({ id: "credit.card.charge" })
    }
  ]
  const verifyAccount = props.intl.formatMessage({ id: "verify.account.with.email" });
  const addSocialAccount = props.intl.formatMessage({ id: "add.social.account.to.leave.reviews" });
  const stayRelevant = props.intl.formatMessage({ id: "stay.relevant" });
  const weOfferPlans = props.intl.formatMessage({ id: "we.offer.plans.for.all" });
  const tryEachPlan = props.intl.formatMessage({ id: "try.each.plan.for.free" });
  const seeCompletePricing = props.intl.formatMessage({ id: "see.complete.pricing.info" });
  const online = props.intl.formatMessage({ id: "online" });
  const business = props.intl.formatMessage({ id: "business" });
  const enterprise = props.intl.formatMessage({ id: "enterprise" });
  const yearly = props.intl.formatMessage({ id: "yearly" });
  const monthly = props.intl.formatMessage({ id: "monthly" });
  const freeForever = props.intl.formatMessage({ id: "free.forever" });
  const startForFree = props.intl.formatMessage({ id: "start.for.free" });

  const headerCus = (
    <GridContainer>
      <GridItem
        xs={12}
        sm={12}
        md={8}
        className={classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter}
      >
      <h2 className={classes.description}>
        {verifyAccount}
      </h2>
      <h3 className={classes.description}>
        {addSocialAccount}
      </h3>
    </GridItem>
  </GridContainer>
  );

  const headerPro = (
    <GridContainer>
      <GridItem
        xs={12}
        sm={12}
        md={8}
        className={classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter}
      >
        <h2 className={classes.title}>
          {stayRelevant}
        </h2>
        <p className={classes.description}>{weOfferPlans} - {tryEachPlan}. <a href={paths.PRICING_PROFESSIONAL}>{seeCompletePricing}</a>.</p>
      </GridItem>
    </GridContainer>
  );

  const header = props.free ? headerCus : headerPro;

  return (
    <div className={classes.pricing + " " + classes.sectionWhite}>
      <div className={classes.container}>
        {header}
        {!props.free && <GridContainer>
          <GridItem
            xs={12}
            className={classes.mlAuto + " " + classes.mrAuto}
          >
            <NavPills
              active={1}
              alignCenter
              color="danger"
              tabs={[
                {
                  tabButton: monthly,
                  tabContent: (
                    <GridContainer>
                      <PricingCard
                        product={online}
                        price={0}
                        features={onlineFeatures}
                        button={freeForever}
                        action={props.member ? paths.SIGN_UP_PLAN + plans.ONLINE_M : 
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ONLINE_M)}
                      />
                      <PricingCard
                        product={business}
                        price={20}
                        features={businessFeatures}
                        button={startForFree}
                        action={props.member ? paths.SIGN_UP_PLAN + plans.BUSINESS_M : 
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.BUSINESS_M)}
                        everythingFrom={online.toString().toUpperCase()}
                      />
                      <PricingCard
                        product={enterprise}
                        price={100}
                        features={enterpriseFeatures}
                        button={startForFree}
                        action={props.member ? paths.SIGN_UP_PLAN + plans.ENTERPRISE_M : 
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ENTERPRISE_M)}
                        everythingFrom={business.toString().toUpperCase()}
                      />
                    </GridContainer>
                  )
                },
                {
                  tabButton: yearly,
                  tabContent: (
                    <GridContainer>
                      <PricingCard
                        product={online}
                        price={0}
                        features={onlineFeatures}
                        button={freeForever}
                        action={props.member ? paths.SIGN_UP_PLAN + plans.ONLINE_Y : 
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ONLINE_Y)}
                      />
                      <PricingCard
                        product={business}
                        price={200}
                        features={businessFeatures}
                        button={startForFree}
                        action={props.member ? paths.SIGN_UP_PLAN + plans.BUSINESS_Y : 
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.BUSINESS_Y)}
                        everythingFrom={online.toString().toUpperCase()}
                      />
                      <PricingCard
                        product={enterprise}
                        price={1000}
                        features={enterpriseFeatures}
                        button={startForFree}
                        action={props.member ? paths.SIGN_UP_PLAN + plans.ENTERPRISE_Y : 
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ENTERPRISE_Y)}
                        everythingFrom={business.toString().toUpperCase()}
                      />
                    </GridContainer>
                  )
                }
              ]}
            />
          </GridItem>
        </GridContainer>}
      </div>
    </div>
  );
}
    
export default injectIntl(withStyles(pricingStyle)(SectionPricingShorter));